module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./BusinessCardViewNew.js"));
	}, "BusinessCardView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BusinessCardView!./src/pages/Promote/BusinessCard/BusinessCardViewNew.js
// module id = 1105
// module chunks = 438